// extracted by mini-css-extract-plugin
module.exports = {"row":"SimpleQuestionBuilderModal_row__k06fq","radioRow":"SimpleQuestionBuilderModal_radioRow__2v-df"};